const phoneReplaceRegex = /(\d{2})(?!( )|$)/g;

export const formatPhoneNumber = (value: string | null) => {
  return value?.replace(phoneReplaceRegex, "$1 ") ?? "";
};
